import React, { useState, useMemo } from "react";

function PricingTable({ plans, header, lead }) {
  const [billingPeriod, setBillingPeriod] = useState("monthly");

  const isMonthly = billingPeriod === "monthly";

  const billingOptions = useMemo(
    () => [
      { key: "monthly", label: "Monthly" },
      { key: "annual", label: "Annual", badge: "OFFER" },
    ],
    []
  );

  return (
    <section className="dtf-pricing-section">
      <div className="container">
        <div className="pricing-container">
          <div className="text-center mb-5">
            <div className="dtf-billing-toggle" role="group" aria-label="Billing period">
              {billingOptions.map(({ key, label, badge }) => (
                <button
                  key={key}
                  type="button"
                  onClick={() => setBillingPeriod(key)}
                  className={`dtf-billing-btn ${billingPeriod === key ? "active" : ""}`}
                  aria-pressed={billingPeriod === key}
                >
                  {label}
                  {badge && (
                    <span className="dtf-billing-badge">
                      {badge}
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>

          <div className="row gx-4">
            {plans.map((plan) => (
              <div key={plan.name} className="col-lg mb-2 d-flex">
                <div className={`dtf-pricing-card ${plan.recommended ? "dtf-pricing-card--recommended" : ""}`}>
                  {plan.recommended && (
                    <span className="dtf-pricing-popular">POPULAR</span>
                  )}

                  <div className="dtf-pricing-card-header">
                    <span className="dtf-pricing-plan-name">{plan.name}</span>
                    <div className="dtf-pricing-price">
                      <span className="price">
                        {isMonthly ? plan.price_monthly : plan.price_annual}
                      </span>
                      <span className="dtf-pricing-period">
                        {isMonthly ? "monthly" : "annually"}
                      </span>
                    </div>
                    <a
                      href={isMonthly ? plan.pricing_url_monthly : plan.pricing_url_annual}
                      className="dtf-btn-primary w-100"
                    >
                      Choose this plan
                    </a>
                  </div>

                  <div className="dtf-pricing-card-body">
                    <ul className="list-unstyled">
                      {plan.entitlements.map((entitlement, index) => (
                        <li key={index} className="dtf-pricing-entitlement">
                          <i className="fas fa-check" aria-hidden="true" />
                          {entitlement}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PricingTable;
